import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { ApiFile } from 'app/models/api-response';

@Injectable({
  providedIn: 'root',
})
export class FileManipulationService {
  private readonly coreVersion: string = `v1/core/`;

  constructor(private apiService: ApiService) {}

  getDownloadFile(fileId: any): Observable<Blob> {
    const slug: string = `${this.coreVersion}` + `download/${fileId}`;
    return this.apiService.get(slug, '', '', { responseType: 'blob' });
  }

  getFileWithTag(tag: string): Observable<ApiFile> {
    const slug: string =
      `${this.coreVersion}` + `file/tag/${tag.toUpperCase()}`;
    return this.apiService.get(slug, '', '');
  }

  // Type 9 is for TB_CLEANSED_FILE
  // Type 10 is for TBE_USER_UPLOADED_CLEANSED_FILE
  // Type 11 is for COA_LVL1_MAPPING
  // Type COA_ALL_LVL_MAPPING = 13
  // Type 12 is for COA_USER_UPLOADED_LVL1_MAPPING
  // in the case the type is not provided we use 9 as default
  getCleansedFile(
    files: ApiFile[],
    checkIfTypeTenExists: boolean,
    type: number = 9
  ): ApiFile | undefined {
    if (checkIfTypeTenExists) {
      let fileToReturn = files.find((f) => f.type === 10);

      if (fileToReturn) {
        return fileToReturn;
      } else {
        fileToReturn = files.find((f) => f.type === 9);
        return fileToReturn;
      }
    } else {
      const file = files.find((f: ApiFile) => f.type === type);

      if (file) {
        return file;
      }
      return undefined;
    }
  }
}
